

interface TimeDropdownProps {
  value: string;
  onChange: (time: string) => void;
  className?: string;
  required?: boolean;
}

export function TimeDropdown({ value, onChange, className = '', required = false }: TimeDropdownProps) {
  // Generate time options in 24-hour format (00:00 to 23:59)
  const timeOptions: string[] = [];

  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) { // 15-minute intervals
      const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      timeOptions.push(timeString);
    }
  }

  // Format value to HH:MM (remove seconds if present, e.g. "10:00:00" -> "10:00")
  const formattedValue = value ? value.substring(0, 5) : ''

  // Check if formatted value exists in options
  const isValidValue = formattedValue && timeOptions.includes(formattedValue)

  return (
    <select
      value={isValidValue ? formattedValue : ''}
      onChange={(e) => onChange(e.target.value)}
      className={`input-field time-dropdown ${className}`}
      required={required}
    >
      {!isValidValue && (
        <option value="" disabled>
          {formattedValue || 'Välj tid...'}
        </option>
      )}
      {timeOptions.map((time) => (
        <option key={time} value={time}>
          {time}
        </option>
      ))}
    </select>
  );
}
